export default __webpack_public_path__ + "static/media/login_bg.d04f14ae.png";